<div class="main-container" [@pageFadeUp]>
  <div class="logo-wrapper stagger-item">
    <img
      src="https://vsmps.varuna-sentinels.com/assets/img/favicon.png"
      alt="Varuna Sentinels Logo"
      class="logo"
    />
    <h2 class="title">VARUNA SENTINELS</h2>
  </div>
  <div class="token-login-container" [@staggerFadeUp]>
    <div class="login-box stagger-item" [@staggerFadeUp]>
      <div class="input-group stagger-item">
        <i class="fa fa-lock"></i>
        <input
          type="text"
          placeholder="Please enter Security Token"
          [(ngModel)]="securityToken"
        />
      </div>
      <button
        (click)="verifyToken()"
        class="login-btn stagger-item"
        [disabled]="loading"
      >
        <ng-container *ngIf="!loading; else loadingTpl">Login</ng-container>
        <ng-template #loadingTpl>
          <span class="btn-loading">
            <mat-progress-spinner
              class="btn-spinner"
              [diameter]="16"
              [strokeWidth]="3"
              mode="indeterminate"
            ></mat-progress-spinner>
            <span class="ml-8">Verifying...</span>
          </span>
        </ng-template>
      </button>
    </div>
  </div>
</div>
